import axios from "axios";
import { io } from "socket.io-client";

//let baseURL = "http://192.168.1.36:9008";
export const backendServer = "https://studio.upstyled.co";
let baseURL = backendServer;

// takes precedence over GATSBY_STORE_URL

if (process.env.GATSBY_MEDUSA_BACKEND_URL) {
  baseURL = process.env.GATSBY_MEDUSA_BACKEND_URL;
}

const client = axios.create({ baseURL });

export default function medusaRequest(method, path = "", payload = {}) {
  const options = {
    method,
    withCredentials: true,
    url: path,
    data: payload,
    json: true,
  };
  return client(options);
}

export function medusaDownload(path = "") {
  window.open(backendServer + path);
}

export const multipartRequest = (path, payload, config = {}) => {
  const options = {
    withCredentials: true,
    headers: {
      "content-type": "multipart/form-data",
    },
    ...config,
  };

  return client.post(path, payload, options);
};

export const socket = io(backendServer);
